import * as React from 'react';

import classnames from 'classnames';
import _ from 'underscore';

import {Popover} from '../popover/popover';

import styles from './limited-group.module.css';

type Props = {
    models: React.ReactNode[];
    numDisplayed: number | string;
    isHoverable?: boolean;
    shouldTruncate?: boolean;
    includeMoreWord?: boolean;
    shouldFlex?: boolean;
};

type State = {
    popoverIsOpen: boolean;
};

export class LimitedGroup extends React.PureComponent<Props, State> {
    hiddenAnchor: HTMLElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            popoverIsOpen: false,
        };
    }

    render() {
        const numDisplayed = Number(this.props.numDisplayed);
        const shownStyle = this.props.shouldTruncate ? styles['shown-truncate'] : styles.shown;
        const containerStyle = this.props.shouldTruncate
            ? styles['container-truncate']
            : styles.container;

        if (this.props.models.length <= numDisplayed) {
            return (
                <div className={containerStyle}>
                    <div className={classnames(this.props.shouldFlex ? 'flex' : '', shownStyle)}>
                        {this.props.models}
                    </div>
                </div>
            );
        }

        const shownModels = _.first(this.props.models, numDisplayed);
        const hiddenModels = _.last(this.props.models, this.props.models.length - numDisplayed);

        return (
            <div className={containerStyle}>
                <div className={classnames(this.props.shouldFlex ? 'flex' : '', shownStyle)}>
                    {shownModels}
                </div>
                <div
                    className={this.props.isHoverable ? styles['hidden--hoverable'] : styles.hidden}
                >
                    <span
                        ref={(c) => {
                            this.hiddenAnchor = c;
                        }}
                        onMouseOver={this.handleMouseOver}
                        onMouseOut={this.handleMouseOut}
                    >
                        + {hiddenModels.length}
                        {this.props.includeMoreWord ? ' more' : ''}
                    </span>
                    {this.state.popoverIsOpen ? (
                        <Popover
                            className='ui-popover ui-popover--md'
                            location='bottom'
                            anchor={this.hiddenAnchor}
                        >
                            {hiddenModels}
                        </Popover>
                    ) : undefined}
                </div>
            </div>
        );
    }

    handleMouseOver = () => {
        if (this.props.isHoverable) {
            this.setState({popoverIsOpen: true});
        }
    };

    handleMouseOut = () => {
        this.setState({popoverIsOpen: false});
    };
}
